import { NavLink, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import logo from "../../icons/LogoPiSeunImg.png";
import { useStoreLogin } from "../../paginas/Login/useStoreLogin";
import { obtenerGruposPermitidos } from "../../config/navegacion";
import "./menuInferior.css";

const MenuInferior = ({ disabled = false }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const [abrirMenu, setAbrirMenu] = useState(false);
  const grupos = obtenerGruposPermitidos();

  useEffect(() => setAbrirMenu(false), [location.pathname]);

  useEffect(() => {
    if (!abrirMenu) return undefined;
    const cerrarConEscape = (event) => event.key === "Escape" && setAbrirMenu(false);
    document.addEventListener("keydown", cerrarConEscape);
    return () => document.removeEventListener("keydown", cerrarConEscape);
  }, [abrirMenu]);

  const handleLogout = () => {
    useStoreLogin.getState().logout();
    setAbrirMenu(false);
    navigate("/home", { replace: true });
  };

  const irA = (ruta) => {
    if (disabled) return;
    setAbrirMenu(false);
    navigate(ruta);
  };

  const esRutaActiva = (ruta) => location.pathname === ruta ||
    (ruta === "/reportes" && location.pathname.startsWith("/reportes/")) ||
    (ruta === "/produccion" && ["/produccion-entradas", "/produccion-salidas"].includes(location.pathname));

  const contenidoNavegacion = (movil = false) => (
    <>
      <NavLink
        to="/home"
        className={`menu-item menu-item-inicio ${location.pathname === "/home" ? "activo" : ""}`}
        onClick={(event) => disabled && event.preventDefault()}
      >
        <i className="pi pi-home" aria-hidden="true" />
        <span>Inicio</span>
      </NavLink>
      {grupos.map((grupo) => (
        <section className="menu-grupo" key={grupo.id} aria-labelledby={`menu-${grupo.id}${movil ? "-movil" : ""}`}>
          <h2 id={`menu-${grupo.id}${movil ? "-movil" : ""}`}>{grupo.titulo}</h2>
          {grupo.opciones.map((opcion) => (
            <button
              type="button"
              key={opcion.ruta}
              className={`menu-item ${esRutaActiva(opcion.ruta) ? "activo" : ""}`}
              aria-current={esRutaActiva(opcion.ruta) ? "page" : undefined}
              disabled={disabled}
              onClick={() => irA(opcion.ruta)}
            >
              <i className={`pi ${opcion.icono}`} aria-hidden="true" />
              <span>{opcion.label}</span>
            </button>
          ))}
        </section>
      ))}
    </>
  );

  return (
    <>
      <aside className="menu-lateral" aria-label="Navegación principal">
        <div className="menu-marca">
          <NavLink
            to="/home"
            className="menu-marca-icono"
            aria-label="Ir al inicio"
            aria-disabled={disabled || undefined}
            onClick={(event) => disabled && event.preventDefault()}
          >
            <img src={logo} alt="" />
          </NavLink>
          <span className="menu-marca-nombre">PiSeun</span>
        </div>
        <nav className="menu-lateral-opciones" aria-label="Secciones">{contenidoNavegacion()}</nav>
        <button type="button" className="menu-item menu-logout" onClick={handleLogout}>
          <i className="pi pi-sign-out" aria-hidden="true" />
          <span>Cerrar sesión</span>
        </button>
      </aside>

      <button type="button" className={`menu-overlay ${abrirMenu ? "visible" : ""}`} aria-label="Cerrar menú" tabIndex={abrirMenu ? 0 : -1} onClick={() => setAbrirMenu(false)} />

      <aside className={`submenu ${abrirMenu ? "visible" : ""}`} aria-label="Menú principal" aria-hidden={!abrirMenu}>
        <header className="submenu-cabecera">
          <div><strong>Menú principal</strong><span>Elegí qué querés hacer</span></div>
          <button type="button" aria-label="Cerrar menú" onClick={() => setAbrirMenu(false)}><i className="pi pi-times" aria-hidden="true" /></button>
        </header>
        <nav className="submenu-contenido">{contenidoNavegacion(true)}</nav>
        <button type="button" className="menu-item menu-logout" onClick={handleLogout}>
          <i className="pi pi-sign-out" aria-hidden="true" /><span>Cerrar sesión</span>
        </button>
      </aside>

      <nav className="menu-inferior" aria-label="Navegación móvil">
        <NavLink to="/home" className={location.pathname === "/home" ? "activo" : ""}>
          <i className="pi pi-home" aria-hidden="true" /><span>Inicio</span>
        </NavLink>
        <button type="button" className="btn-menu" aria-label={abrirMenu ? "Cerrar menú" : "Abrir menú"} aria-expanded={abrirMenu} onClick={() => setAbrirMenu((valor) => !valor)}>
          <i className={`pi ${abrirMenu ? "pi-times" : "pi-bars"}`} aria-hidden="true" /><span>Menú</span>
        </button>
      </nav>
    </>
  );
};

export default MenuInferior;
